// extracted by mini-css-extract-plugin
export default {"tableBanner":"TableBanners_tableBanner__agaku","buttonWrapper":"TableBanners_buttonWrapper__AIwqd"};